export default "__VITE_ASSET__BJmZfiyx__"